export default __webpack_public_path__ + "761c3da8724e82ea8c4d5c93456c527c.svg";